import(/* webpackMode: "eager" */ "/tmp/8de72f5d4476240/app/[locale]/error.tsx");
